import { observer } from 'mobx-react';
import ShareUrlsOptionsStore from '../DeepLinksOptionsStore';
import { SearchParameter, SearchParameters } from '../../../../../../ListFilter/Types';
import Body from './Body';
import Skeleton from './Skeleton';

interface Props {
  duplicateProgramDeepLinkCount: number;
  optionsStore: ShareUrlsOptionsStore;
  searchParameters: SearchParameters;
  updatingSearchParameters: (searchParameter: SearchParameter) => void;
}

function FilterState({
  duplicateProgramDeepLinkCount,
  optionsStore,
  searchParameters,
  updatingSearchParameters,
}: Props) {
  const state = optionsStore.state;
  switch (state.kind) {
    case 'loading':
    case 'waiting':
      return <Skeleton />;
    case 'ready':
      return (
        <Body
          duplicateProgramDeepLinkCount={duplicateProgramDeepLinkCount}
          resource={state.resource}
          searchParameters={searchParameters}
          updatingSearchParameters={updatingSearchParameters}
        />
      );
    case 'error':
      return <></>;
  }
}
export default observer(FilterState);
